export default __webpack_public_path__ + "static/media/759.8f34ab55.png";